
const Help = () => {
  return (
    <iframe className="h-full" src="https://help.ppmeasy.com/" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
  )
}

export default Help